/** Paths below are the messenger's own router paths (/chats, /chats/123, /stories/…), not browser URLs. */

const normalize = (route: string) => route.replace(/\/+$/, '') || '/';

/** The chat list itself: the only place the site's bottom navigation stays on screen. */
export const isHamiMainChatsRoute = (route: string) => {
  const path = normalize(route);
  return path === '/' || path === '/chats';
};

/** Ticket id of an open conversation; null on the list, settings, stories and profiles. */
export const getHamiChatIdFromRoute = (route: string) => {
  const match = normalize(route).match(/^\/chats\/([^/]+)$/);
  if (!match || match[1] === 'settings' || match[1] === 'announcements') return null;
  return decodeURIComponent(match[1]);
};

/** Next page templates (router.pathname) of the messenger's screens. */
export const HAMI_PAGE_PATHNAMES = [
  '/_/chats/[[...slug]]',
  '/_/chat-profile',
  '/_/chat-profile/[remoteId]',
  '/_/chat-health-record',
  '/_/stories',
  '/_/stories/create',
  '/_/stories/[id]',
  '/_/calls/room',
];
